import React, { useEffect } from 'react';
import _ from 'underscore';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Button, Card, CardContent, CardActions, Grid, Divider, TextField, colors } from '@mui/material';
import DatePicker from 'components/DatePicker/DatePicker';
import { SelectField } from 'components';
import validate from 'validate.js';
import { TopOffendersAggCityExport, SetFormState } from '../../actions/TopOffendersAggCityActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const schema = {
	region: {
		presence: { allowEmpty: false, message: 'is required' },
	},
	startDate: {
		presence: { allowEmpty: false, message: 'is required' },
	},
	endDate: {
		presence: { allowEmpty: false, message: 'is required' },
	}
};

const regions = [
	{ value: 'All Cities', text: 'All Cities' },
	{ value: 'Belfast', text: 'Belfast' },
	{ value: 'Birmingham', text: 'Birmingham' },
	{ value: 'Leeds_Bradford', text: 'Leeds_Bradford' },
	{ value: 'Bristol', text: 'Bristol' },
	{ value: 'Cardiff', text: 'Cardiff' },
	{ value: 'Coventry', text: 'Coventry' },
	{ value: 'Edinburgh', text: 'Edinburgh' },
	{ value: 'Glasgow', text: 'Glasgow' },
	{ value: 'Southampton_Portsmouth', text: 'Southampton_Portsmouth' },
	{ value: 'Leicester', text: 'Leicester' },
	{ value: 'Liverpool', text: 'Liverpool' },
	{ value: 'London', text: 'London' },
	{ value: 'Manchester', text: 'Manchester' },
	{ value: 'Newcastle upon Tyne', text: 'Newcastle upon Tyne' },
	{ value: 'Nottingham', text: 'Nottingham' },
	{ value: 'Sheffield', text: 'Sheffield' }
];

const TopOffendersAggCityForm = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.TopOffendersAggCityReducer.formState);

	useEffect(() => {
		const errors = validate(formState.values, schema);

		setFormState({
			...formState,
			isValid: !errors,
			errors: errors || {},
		});
	}, [formState.values]);

	const _handleChange = (event) => {
		const errors = validate(formState.values, schema);
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			}
		});
	};

	const _handleDateChange = (value, name) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[name]: value,
			},
			touched: {
				...formState.touched,
				[name]: true,
			},
		});
	};

	const _hasError = (field) => (!!(formState.touched[field] && formState.errors[field]));
	const user = useSelector(state => state.session.user);
	const _generate = () => {
		dispatch(TopOffendersAggCityExport(formState.values, user.id));
	};

	return (
		<Card className={classes.content}>
			<CardContent>
				<Grid container spacing={1}>
					<Grid item md={8} xs={12}>
						<SelectField
							id="region"
							name="region"
							value={formState.values.region || ''}
							onChange={_handleChange}
							hintText="City"
							menuItems={regions}
							error={_hasError('region')}
							helperText={_hasError('region') ? formState.errors.region[0] : null}
						/>
					</Grid>
					<Grid item md={2} xs={12}>
						<DatePicker
							label="Start Date"
							name="startDate"
							value={formState.values.startDate || null}
							onChange={(value) => _handleDateChange(value, 'startDate')}
							error={_hasError('startDate')}
							helperText={_hasError('startDate') ? formState.errors.startDate[0] : null}
						/>
					</Grid>
					<Grid item md={2} xs={12}>
						<DatePicker
							label="End Date"
							name="endDate"
							value={formState.values.endDate || null}
							onChange={(value) => _handleDateChange(value, 'endDate')}
							error={_hasError('endDate')}
							helperText={_hasError('endDate') ? formState.errors.endDate[0] : null}
						/>
					</Grid>
				</Grid>
			</CardContent>
			<Divider />
			<CardActions>
				<Button className={classes.generate} onClick={_generate} variant="contained" disabled={!formState.isValid}>Export</Button>
			</CardActions>
		</Card>
	);
};

export default TopOffendersAggCityForm;
